export default function isValidZip(zip) {
  return /^\d{5}(?:[-\s]\d{4})?$/.test(zip);
}
